module.exports = __webpack_public_path__ + "img/7.98b3c707.webp";